// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__M_nx2","form":"styles_form__1G3WS"};